<div class="confirm-dialog" [class.danger]="data.danger">
  <div class="dialog-header">
    <div class="title">
      <fa-duotone-icon [icon]="faTriangleExclamation"></fa-duotone-icon>
      <span>{{ data.title }}</span>
    </div>
    <button
      type="button"
      class="close-btn"
      [attr.aria-label]="'Close' | translate"
      [andorTooltip]="'Close' | translate"
      tooltipPosition="below"
      (click)="cancel()">
      <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
    </button>
  </div>

  <p class="message">{{ data.message }}</p>

  <div class="actions">
    <button type="button" class="cancel" (click)="cancel()">
      {{ data.cancelLabel ?? ('Cancel' | translate) }}
    </button>
    <button type="button" class="confirm" [class.danger]="data.danger" (click)="confirm()">
      {{ data.confirmLabel ?? ('Confirm' | translate) }}
    </button>
  </div>
</div>
